// Import the functions you need from the SDKs you need
import { FirebaseOptions, initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

import { Env, getEnv } from '../utils/common'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig: () => FirebaseOptions = () => {
  switch (getEnv()) {
    case Env.Prod:
      return {
        apiKey: 'AIzaSyAESAnBsojlXBFhCC3w-K5AsdSY31Z-P2Y',
        authDomain: 'salient-app-76a0e.firebaseapp.com',
        projectId: 'salient-app-76a0e',
        storageBucket: 'salient-app-76a0e.appspot.com',
        messagingSenderId: '1001283036555',
        appId: '1:1001283036555:web:3086358b5f7e891ad07b8e',
        measurementId: 'G-K0369DTGFX'
      }
    case Env.Dev:
    case Env.Local: // fall through
      return {
        apiKey: 'AIzaSyDlmdLJamcTz_tGI7jHL8_5VvIInjcm70A',
        authDomain: 'salient-app-development.firebaseapp.com',
        projectId: 'salient-app-development',
        storageBucket: 'salient-app-development.appspot.com',
        messagingSenderId: '214297191498',
        appId: '1:214297191498:web:d7821e840db7ed1d51f2b3',
        measurementId: 'G-Z0THYS20D1'
      }
    case Env.Legacy:
      return {
        apiKey: 'AIzaSyCjujt4_glcx5gmxfaSfQ1kFI8VK7veEmM',
        authDomain: 'salient-legacy-app-development.firebaseapp.com',
        projectId: 'salient-legacy-app-development',
        storageBucket: 'salient-legacy-app-development.firebasestorage.app',
        messagingSenderId: '169097792469',
        appId: '1:169097792469:web:60e11d84afb9cf62c70b5c',
        measurementId: 'G-STBYHG56ZN'
      }
    case Env.Sandbox:
      return {
        apiKey: 'AIzaSyCLd8n6YcVh75ea5XrYQmWE-MGUsxnGfm0',
        authDomain: 'salient-sandbox-development.firebaseapp.com',
        projectId: 'salient-sandbox-development',
        storageBucket: 'salient-sandbox-development.firebasestorage.app',
        messagingSenderId: '213561948441',
        appId: '1:213561948441:web:35a743068dc9af2a0a2d88'
      }
    default:
      throw new Error(`Unexpected environment setting: ${getEnv()}`)
  }
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig())
export const firebaseAuth = getAuth(app)
export const firebaseStore = getFirestore(app)
export const analytics = getAnalytics(app)
export const firebaseFunctions = getFunctions(app)
